module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"canton-label":"Kanton"},"fr":{"canton-label":"Canton"},"it":{"canton-label":"Cantone"}}')
  delete Component.options._Ctor
}
